import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ChartComponentSettings,
    ComponentSettingsChartMeasureField,
    NewBlockContextType,
    SimpleFormattingRule,
} from '@report-content';
import { YNValues } from 'tools/types';

export class BlockFactoryBubbleChart extends AbstractBlockFactory<ComponentSettingsBubbleChart> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsBubbleChart> {
        const uid = 'block_uid_' + nextUId;
        const fieldNumericField = datasetFields.find((f) => f.value_type == 'numeric');
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'bubble_chart',
                settings: {
                    uid: uid,
                    internal_name: 'bubble_chart',
                    // component_name: 'Pie',

                    dataQueries: {
                        table: {
                            resultFieldAggregations: {},
                            resultFields: [],
                            sort: [],
                        },
                    },

                    component_name: 'Bubble',
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    // localPalette: {},
                    groupFilter: { operator: 'AND', rules: [] },
                    //@ts-ignore
                    name_field: datasetFields[0],
                    //@ts-ignore
                    x_field: fieldNumericField ?? datasetFields[0],
                    //@ts-ignore
                    y_field: fieldNumericField ?? datasetFields[0],
                    //@ts-ignore
                    value_field: datasetFields[0],
                    display_value: 'N',
                    display_label: 'Y',
                    x_axis_plot_intermediate_values: 'Y',
                    y_axis_plot_intermediate_values: 'Y',
                    formattingRules: [],
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    drillTo: [],
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsBubbleChart extends ChartComponentSettings {
    uid: string;
    component_name: 'Bubble';
    name_field: ComponentSettingsChartMeasureField;
    x_field: ComponentSettingsChartMeasureField;
    y_field: ComponentSettingsChartMeasureField;
    value_field: ComponentSettingsChartMeasureField;
    display_value: YNValues;
    display_label: YNValues;
    x_axis_plot_intermediate_values: YNValues;
    y_axis_plot_intermediate_values: YNValues;
    formattingRules: Array<SimpleFormattingRule>;
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
}
